/*
 *             Copyright (c) 2016 - 2022, CKSource Holding sp. z o.o. All rights reserved.
 *
 *
 *
 *
 *          +---------------------------------------------------------------------------------+
 *          |                                                                                 |
 *          |                                 Hello stranger!                                 |
 *          |                                                                                 |
 *          |                                                                                 |
 *          |   What you're currently looking at is the source code of a legally protected,   |
 *          |    proprietary software. Any attempts to deobfuscate / disassemble this code    |
 *          |               are forbidden and will result in legal consequences.              |
 *          |                                                                                 |
 *          |                                                                                 |
 *          +---------------------------------------------------------------------------------+
 *
 *
 *
 *
 */
const _0xa3a1=['markerNameToElements','mapViewToDom','view','domConverter'];(function(_0x315a3e,_0xa3a1a4){const _0x10daa4=function(_0x3556d8){while(--_0x3556d8){_0x315a3e['push'](_0x315a3e['shift']());}};_0x10daa4(++_0xa3a1a4);}(_0xa3a1,0x133));const _0x10da=function(_0x315a3e,_0xa3a1a4){_0x315a3e=_0x315a3e-0x0;let _0x10daa4=_0xa3a1[_0x315a3e];return _0x10daa4;};import{first as _0x2ea9cf}from'ckeditor5/src/utils';export default function x(_0x43ec50,_0x52f08c){const _0x3cfccd=_0x43ec50['mapper'][_0x10da('0x1')](_0x52f08c['name']),_0x35cb04=_0x2ea9cf(_0x3cfccd['values']());return _0x43ec50[_0x10da('0x3')][_0x10da('0x0')][_0x10da('0x2')](_0x35cb04);}